<template>
  <div>
    <div v-if="false" class="cookie-bar">
      <div class="cookie-bar-wrapper">
        <div class="cookie-bar-title">
          {{ $t("cookie.cookie_title") }}
        </div>
        <div class="cookie-bar-text">
          {{ $t("cookie.cookie_description") }}
          <a href="https://siterunner.com/privacy-policy" target="_blank">
            {{ $t("cookie.buttons.privacy_policy") }}.</a
          >
        </div>
        <div class="cookie-bar-buttons-wrapper">
          <button @click="acceptCookies" class="cookie-bar-button cookie-bar-button--accept">
            {{ $t("cookie.buttons.accept_all") }}
          </button>
          <button @click="manageCookies" class="cookie-bar-button cookie-bar-button--manage">
            {{ $t("cookie.buttons.manage_cookies") }}
          </button>
        </div>
      </div>
    </div>

    <cookie-modal class="cookie-modal" :show="openModal">
      <template #header>
        <div class="cookie-modal-header">
          {{ $t("cookie.modal.title") }}
        </div>
      </template>
      <template #body>
        <div class="cookie-modal-body">
          <accordion-wrapper>
            <accordion-item>
              <template #accordion-trigger>
                <div class="accordion-header">
                  <img src="@/assets/images/svg/arrow-right.svg" alt="arrow-right" />
                  <h6>{{ $t("cookie.modal.necessary") }}</h6>
                  <div class="aside-text">{{ $t("cookie.modal.always_active") }}</div>
                </div>
              </template>

              <template #accordion-content>
                <p class="accordion-body">
                  {{ $t("cookie.modal.necessary_text") }}
                </p>
              </template>
            </accordion-item>
            <accordion-item>
              <template #accordion-trigger>
                <div class="accordion-header">
                  <img src="@/assets/images/svg/arrow-right.svg" alt="arrow-right" />
                  <h6>{{ $t("cookie.modal.functional") }}</h6>
                </div>
              </template>
              <template #accordion-no-trigger>
                <toggle-switch
                  :modelValue="cookieValues.functional"
                  @update:modelValue="e => (cookieValues.functional = e)">
                </toggle-switch>
              </template>

              <template #accordion-content>
                <p class="accordion-body">
                  {{ $t("cookie.modal.functional_text") }}
                </p>
              </template>
            </accordion-item>
            <accordion-item>
              <template #accordion-trigger>
                <div class="accordion-header">
                  <img src="@/assets/images/svg/arrow-right.svg" alt="arrow-right" />
                  <h6>{{ $t("cookie.modal.marketing") }}</h6>
                </div>
              </template>
              <template #accordion-no-trigger>
                <toggle-switch
                  :modelValue="cookieValues.marketing"
                  @update:modelValue="e => (cookieValues.marketing = e)">
                </toggle-switch>
              </template>

              <template #accordion-content>
                <p class="accordion-body">
                  {{ $t("cookie.modal.marketing_text") }}
                </p>
              </template>
            </accordion-item>
            <accordion-item>
              <template #accordion-trigger>
                <div class="accordion-header">
                  <img src="@/assets/images/svg/arrow-right.svg" alt="arrow-right" />
                  <h6>{{ $t("cookie.modal.analytical") }}</h6>
                </div>
              </template>
              <template #accordion-no-trigger>
                <toggle-switch
                  :modelValue="cookieValues.analytical"
                  @update:modelValue="e => (cookieValues.analytical = e)">
                </toggle-switch>
              </template>

              <template #accordion-content>
                <p class="accordion-body">
                  {{ $t("cookie.modal.analytical_text") }}
                </p>
              </template>
            </accordion-item>
            <accordion-item>
              <template #accordion-trigger>
                <div class="accordion-header">
                  <img src="@/assets/images/svg/arrow-right.svg" alt="arrow-right" />
                  <h6>{{ $t("cookie.modal.statistical") }}</h6>
                </div>
              </template>
              <template #accordion-no-trigger>
                <toggle-switch
                  :modelValue="cookieValues.statistical"
                  @update:modelValue="e => (cookieValues.statistical = e)">
                </toggle-switch>
              </template>

              <template #accordion-content>
                <p class="accordion-body">
                  {{ $t("cookie.modal.statistical_text") }}
                </p>
              </template>
            </accordion-item>
          </accordion-wrapper>
        </div>
      </template>
      <template #footer>
        <div class="cookie-modal-footer">
          <div>
            <button @click="declineCookies" class="cookie-modal-button cookie-modal-button--decline">
              {{ $t("cookie.buttons.decline_all") }}
            </button>
          </div>

          <div>
            <button @click="acceptCookies" class="cookie-modal-button">
              {{ $t("cookie.buttons.accept_all") }}
            </button>
            <button @click="saveCookieSetting" class="cookie-modal-button cookie-modal-button--primary">
              {{ $t("cookie.buttons.save_settings") }}
            </button>
          </div>
        </div>
      </template>
    </cookie-modal>
  </div>
</template>

<script>
  import CookieModal from "@/components/custom/CookieModal.vue";
  import AccordionItem from "@/components/custom/AccordionItem.vue";
  import AccordionWrapper from "@/components/custom/AccordionWrapper.vue";
  import ToggleSwitch from "@/components/custom/ToggleSwitch.vue";
  import { getCookie, setCookie } from "@/utility/cookieFunctions";
  import { loadScripts } from "@/utility/3rdPartyScripts";

  export default {
    components: { AccordionWrapper, AccordionItem, CookieModal, ToggleSwitch },
    data() {
      return {
        showCookieBar: false,
        openModal: false,
        cookieValues: {
          functional: true,
          marketing: true,
          analytical: true,
          statistical: true,
        },
      };
    },
    beforeMount() {
      this.showCookieBar = !getCookie("cookie_list");
    },
    methods: {
      acceptCookies() {
        this.showCookieBar = false;
        this.openModal = false;

        this.cookieValues.functional = true;
        this.cookieValues.marketing = true;
        this.cookieValues.analytical = true;
        this.cookieValues.statistical = true;

        setCookie("cookie_list", this.cookieValues, 180);
        loadScripts(this.cookieValues);
      },
      declineCookies() {
        this.showCookieBar = false;
        this.openModal = false;

        this.cookieValues.functional = false;
        this.cookieValues.marketing = false;
        this.cookieValues.analytical = false;
        this.cookieValues.statistical = false;

        setCookie("cookie_list", this.cookieValues, 180);
      },
      saveCookieSetting() {
        this.showCookieBar = false;
        this.openModal = false;

        setCookie("cookie_list", this.cookieValues, 180);
        loadScripts(this.cookieValues);
      },
      manageCookies() {
        this.openModal = true;
      },
    },
  };
</script>

<style lang="scss">
  .cookie-bar {
    font-family: "Inter", sans-serif;
    background-color: white;
    padding: 24px;
    position: fixed;
    bottom: 24px;
    right: 0;
    left: 24px;
    border-radius: 8px;
    z-index: 9999;
    max-width: 432px;
    width: calc(100% - 32px);
    box-shadow: 3px 3px 10px 0 rgba(69, 64, 78, 0.15);

    @media (max-width: 767px) {
      padding: 16px;
      bottom: 0;
      left: 16px;
    }

    &-wrapper {
      display: flex;
      flex-direction: column;
    }

    &-title {
      font-size: 22px;
      font-weight: 600;
      line-height: 32px;
      color: black;
      margin-bottom: 12px;
    }

    &-text {
      font-size: 16px;
      line-height: 26px;
      color: #6c6c7d;
      text-align: justify;
      margin-bottom: 24px;

      a {
        text-decoration: underline;
        color: #6c6c7d !important;
        font-weight: 700;

        &:hover {
          text-decoration: none;
        }
      }
    }

    &-buttons-wrapper {
      display: flex;
      flex-direction: column;
    }

    &-button {
      font-size: 16px;
      line-height: 24px;
      color: white;
      font-weight: 500;
      cursor: pointer;
      transition: all 0.2s ease;
      padding: 16px 24px;
      border-radius: 8px;

      &--manage {
        color: #45404e;
        border: 1px solid #939099;
        &:hover {
          background-color: #f7f6ff;
          border-color: #6a49ef;
          color: #6a49ef;
        }
      }

      &--accept {
        color: white;
        background-color: #6a49ef;
        margin-bottom: 16px;
        &:hover {
          background-color: #886df2;
        }
      }
    }
  }

  .cookie-modal {
    font-family: "Inter", sans-serif;
    &-header {
      font-size: 16px;
      line-height: 24px;
      color: #201f37;
      margin-bottom: 24px;
    }

    &-body {
      .accordion {
        padding: 0;
      }
      .accordion-header {
        display: flex;
        align-items: center;
        width: 100%;

        img {
          width: 24px;
        }

        h6 {
          font-size: 16px;
          line-height: 24px;
          font-weight: bold;
          color: #45404e;
          margin-left: 4px;
          text-align: start;
        }

        .aside-text {
          font-size: 12px;
          line-height: 24px;
          font-weight: 500;
          color: #45404e;
          margin-left: auto;
          text-align: right;
        }
      }

      .accordion-body {
        font-size: 14px;
        line-height: 24px;
        color: #6c6c7d;
        margin-top: 8px;
      }

      .accordion__trigger_active {
        .accordion-header {
          img {
            transform: rotate(90deg);
          }
        }
      }
    }

    &-footer {
      display: flex;
      justify-content: space-between;
      margin-top: 24px;
    }

    &-button {
      font-size: 14px;
      font-weight: 500;
      color: #6a49ef;
      border: 1px solid #6a49ef;
      border-radius: 4px;
      cursor: pointer;
      transition: all 0.2s ease;
      padding: 8px 22px;
      &:first-child {
        margin-right: 12px;
      }
      &:hover {
        background-color: #e1dbfc;
      }
      @media (max-width: 767px) {
        padding: 8px 10px;
      }

      &--primary {
        color: #ffffff;
        background-color: #6a49ef;
        margin: 0 !important;
        &:hover {
          background-color: #886df2;
        }
      }

      &--decline {
        border-color: transparent;
        margin: 0;
      }
    }
  }
</style>
